import React, { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./../../../assets/css/mentor/mentordashboard/Chatlist.css";
import MyMasterLayout from "./../../../layouts/Mentor/MyMasterlayout";

// ── Data ─────────────────────────────────────────────────────────────────────
const conversations = [
  {
    id: 1,
    type: "group",
    studentName: "Web Development Batch A",
    studentAvatar: "https://i.pravatar.cc/150?img=10",
    lastMessage: "John: Thanks for the assignment feedback!",
    lastMessageTime: new Date(Date.now() - 5 * 60 * 1000),
    unreadCount: 3,
    isOnline: true,
    isTyping: false,
    isPinned: true,
    memberCount: 12,
    bio: "Group chat for Web Development Batch A students.",
    course: "Web Development",
    members: [
      { name: "John Smith", avatar: "https://i.pravatar.cc/150?img=12" },
      { name: "Sarah Khan", avatar: "https://i.pravatar.cc/150?img=5" },
      { name: "Ali Raza", avatar: "https://i.pravatar.cc/150?img=8" },
      { name: "Maria Lopez", avatar: "https://i.pravatar.cc/150?img=6" },
    ],
    sharedFiles: [
      {
        name: "HTML_Basics.pdf",
        size: "2.4 MB",
        icon: "bi-file-earmark-pdf-fill",
        color: "#ef4444",
      },
      {
        name: "CSS_Flexbox_Notes.docx",
        size: "1.1 MB",
        icon: "bi-file-earmark-word-fill",
        color: "#3b82f6",
      },
      {
        name: "Project_Starter.zip",
        size: "5.8 MB",
        icon: "bi-file-earmark-zip-fill",
        color: "#f59e0b",
      },
    ],
    sharedLinks: [
      { title: "MDN Web Docs", url: "developer.mozilla.org" },
      { title: "CSS Tricks", url: "css-tricks.com" },
    ],
  },
  {
    id: 2,
    type: "individual",
    studentName: "Sarah Ahmed",
    studentAvatar: "https://i.pravatar.cc/150?img=1",
    lastMessage: "Can we schedule a session for tomorrow?",
    lastMessageTime: new Date(Date.now() - 15 * 60 * 1000),
    unreadCount: 2,
    isOnline: true,
    isTyping: true,
    isPinned: true,
    bio: "Passionate frontend developer. Learning React & design systems.",
    course: "Web Development",
    joinedDate: "Feb 2024",
    progress: 72,
    sharedFiles: [
      {
        name: "Portfolio_Draft.pdf",
        size: "3.2 MB",
        icon: "bi-file-earmark-pdf-fill",
        color: "#ef4444",
      },
      {
        name: "React_Notes.docx",
        size: "890 KB",
        icon: "bi-file-earmark-word-fill",
        color: "#3b82f6",
      },
    ],
    sharedLinks: [
      { title: "Her GitHub", url: "github.com/sarah-a" },
      { title: "Figma Board", url: "figma.com/board/xyz" },
    ],
  },
  {
    id: 3,
    type: "individual",
    studentName: "Ali Hassan",
    studentAvatar: "https://i.pravatar.cc/150?img=2",
    lastMessage: "I completed the React assignment",
    lastMessageTime: new Date(Date.now() - 2 * 60 * 60 * 1000),
    unreadCount: 0,
    isOnline: true,
    isTyping: false,
    isPinned: false,
    bio: "Backend enthusiast exploring full-stack development.",
    course: "React.js Advanced",
    joinedDate: "Jan 2024",
    progress: 58,
    sharedFiles: [
      {
        name: "React_Assignment.zip",
        size: "4.1 MB",
        icon: "bi-file-earmark-zip-fill",
        color: "#f59e0b",
      },
    ],
    sharedLinks: [
      { title: "Assignment Repo", url: "github.com/ali-h/react-task" },
    ],
  },
  {
    id: 4,
    type: "group",
    studentName: "Python Data Science Group",
    studentAvatar: "https://i.pravatar.cc/150?img=11",
    lastMessage: "Maria: When is the next live session?",
    lastMessageTime: new Date(Date.now() - 3 * 60 * 60 * 1000),
    unreadCount: 5,
    isOnline: false,
    isTyping: false,
    isPinned: false,
    memberCount: 8,
    bio: "Python & Data Science learning group.",
    course: "Python Data Science",
    members: [
      { name: "Maria Lopez", avatar: "https://i.pravatar.cc/150?img=6" },
      { name: "Ahmed Khan", avatar: "https://i.pravatar.cc/150?img=7" },
      { name: "Zara Malik", avatar: "https://i.pravatar.cc/150?img=9" },
    ],
    sharedFiles: [
      {
        name: "matplotlib_intro.ipynb",
        size: "1.8 MB",
        icon: "bi-file-earmark-code-fill",
        color: "#8b5cf6",
      },
    ],
    sharedLinks: [{ title: "Kaggle Dataset", url: "kaggle.com/datasets/iris" }],
  },
  {
    id: 5,
    type: "individual",
    studentName: "Fatima Khan",
    studentAvatar: "https://i.pravatar.cc/150?img=3",
    lastMessage: "Thank you for the detailed explanation!",
    lastMessageTime: new Date(Date.now() - 24 * 60 * 60 * 1000),
    unreadCount: 0,
    isOnline: false,
    isTyping: false,
    isPinned: false,
    bio: "UI/UX designer transitioning into frontend development.",
    course: "Web Development",
    joinedDate: "Mar 2024",
    progress: 45,
    sharedFiles: [],
    sharedLinks: [{ title: "Behance Profile", url: "behance.net/fatima-k" }],
  },
];

const chatMessages = {
  1: [
    {
      id: 1,
      sender: "John Smith",
      senderId: 101,
      avatar: "https://i.pravatar.cc/150?img=12",
      message: "Hi everyone! How are you all doing with the HTML assignment?",
      time: "10:30 AM",
      isMe: false,
    },
    {
      id: 2,
      sender: "Me",
      senderId: 0,
      avatar: "https://i.pravatar.cc/150?img=50",
      message:
        "Good morning! I hope everyone is making progress. Let me know if you need help.",
      time: "10:32 AM",
      isMe: true,
    },
    {
      id: 3,
      sender: "Sarah Khan",
      senderId: 102,
      avatar: "https://i.pravatar.cc/150?img=5",
      message: "I have a question about CSS flexbox. Can you explain it again?",
      time: "10:35 AM",
      isMe: false,
    },
    {
      id: 4,
      sender: "Me",
      senderId: 0,
      avatar: "https://i.pravatar.cc/150?img=50",
      message:
        "Sure! Flexbox is a layout model that allows you to design complex layouts easily. Let me share a resource.",
      time: "10:37 AM",
      isMe: true,
    },
    {
      id: 5,
      sender: "John Smith",
      senderId: 101,
      avatar: "https://i.pravatar.cc/150?img=12",
      message: "Thanks for the assignment feedback! Really helpful 👍",
      time: "11:15 AM",
      isMe: false,
    },
  ],
  2: [
    {
      id: 1,
      sender: "Sarah Ahmed",
      senderId: 201,
      avatar: "https://i.pravatar.cc/150?img=1",
      message: "Good morning! I hope you are doing well.",
      time: "9:00 AM",
      isMe: false,
    },
    {
      id: 2,
      sender: "Me",
      senderId: 0,
      avatar: "https://i.pravatar.cc/150?img=50",
      message:
        "Good morning Sarah! Yes, doing great. How can I help you today?",
      time: "9:05 AM",
      isMe: true,
    },
    {
      id: 3,
      sender: "Sarah Ahmed",
      senderId: 201,
      avatar: "https://i.pravatar.cc/150?img=1",
      message:
        "I wanted to discuss my project progress. I have completed the frontend part.",
      time: "9:07 AM",
      isMe: false,
    },
    {
      id: 4,
      sender: "Me",
      senderId: 0,
      avatar: "https://i.pravatar.cc/150?img=50",
      message:
        "That is excellent progress! Can you show me what you have built so far?",
      time: "9:10 AM",
      isMe: true,
    },
    {
      id: 5,
      sender: "Sarah Ahmed",
      senderId: 201,
      avatar: "https://i.pravatar.cc/150?img=1",
      message: "Can we schedule a session for tomorrow?",
      time: "9:45 AM",
      isMe: false,
    },
  ],
  3: [
    {
      id: 1,
      sender: "Ali Hassan",
      senderId: 301,
      avatar: "https://i.pravatar.cc/150?img=2",
      message: "Hello! I have finished the React assignment.",
      time: "8:30 AM",
      isMe: false,
    },
    {
      id: 2,
      sender: "Me",
      senderId: 0,
      avatar: "https://i.pravatar.cc/150?img=50",
      message: "Great work Ali! Please submit it on the portal.",
      time: "8:35 AM",
      isMe: true,
    },
    {
      id: 3,
      sender: "Ali Hassan",
      senderId: 301,
      avatar: "https://i.pravatar.cc/150?img=2",
      message:
        "Done! I have submitted it. Can you review it when you get time?",
      time: "8:40 AM",
      isMe: false,
    },
    {
      id: 4,
      sender: "Me",
      senderId: 0,
      avatar: "https://i.pravatar.cc/150?img=50",
      message: "Absolutely! I will review it today and provide feedback.",
      time: "8:42 AM",
      isMe: true,
    },
  ],
  4: [
    {
      id: 1,
      sender: "Maria Lopez",
      senderId: 401,
      avatar: "https://i.pravatar.cc/150?img=6",
      message: "Hi everyone! Excited for the Python workshop today.",
      time: "2:00 PM",
      isMe: false,
    },
    {
      id: 2,
      sender: "Ahmed Khan",
      senderId: 402,
      avatar: "https://i.pravatar.cc/150?img=7",
      message: "Me too! Looking forward to learning data visualization.",
      time: "2:05 PM",
      isMe: false,
    },
    {
      id: 3,
      sender: "Me",
      senderId: 0,
      avatar: "https://i.pravatar.cc/150?img=50",
      message:
        "Great to see your enthusiasm! We will cover matplotlib and seaborn today.",
      time: "2:10 PM",
      isMe: true,
    },
    {
      id: 4,
      sender: "Maria Lopez",
      senderId: 401,
      avatar: "https://i.pravatar.cc/150?img=6",
      message: "When is the next live session?",
      time: "3:30 PM",
      isMe: false,
    },
  ],
  5: [
    {
      id: 1,
      sender: "Fatima Khan",
      senderId: 501,
      avatar: "https://i.pravatar.cc/150?img=3",
      message: "Thank you so much for the detailed explanation yesterday!",
      time: "Yesterday",
      isMe: false,
    },
    {
      id: 2,
      sender: "Me",
      senderId: 0,
      avatar: "https://i.pravatar.cc/150?img=50",
      message: "You are very welcome! Happy to help anytime.",
      time: "Yesterday",
      isMe: true,
    },
    {
      id: 3,
      sender: "Fatima Khan",
      senderId: 501,
      avatar: "https://i.pravatar.cc/150?img=3",
      message:
        "I finally understood the concept. Your teaching style is amazing!",
      time: "Yesterday",
      isMe: false,
    },
  ],
};

// ── Helpers ───────────────────────────────────────────────────────────────────
const formatTime = (date) => {
  const diffMs = Date.now() - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHrs = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHrs < 24) return `${diffHrs}h ago`;
  if (diffDays === 1) return "Yesterday";
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

// ── Component ─────────────────────────────────────────────────────────────────
const ChatList = () => {
  const [selectedChat, setSelectedChat] = useState(conversations[1]);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("all");
  const [messageInput, setMessageInput] = useState("");
  const [showProfile, setShowProfile] = useState(true);

  const filtered = conversations
    .filter((c) => {
      const matchSearch = c.studentName
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const matchFilter =
        activeFilter === "all" ||
        (activeFilter === "groups" && c.type === "group") ||
        (activeFilter === "individual" && c.type === "individual");
      return matchSearch && matchFilter;
    })
    .sort((a, b) => {
      if (a.isPinned && !b.isPinned) return -1;
      if (!a.isPinned && b.isPinned) return 1;
      return b.lastMessageTime - a.lastMessageTime;
    });

  const handleSend = () => {
    if (messageInput.trim()) setMessageInput("");
  };

  const groupCount = conversations.filter((c) => c.type === "group").length;
  const unreadTotal = conversations.reduce((s, c) => s + c.unreadCount, 0);

  return (
    <MyMasterLayout>
      <div className="mch-root">
        {/* ══════════ PANEL 1 — SIDEBAR ══════════ */}
        <div className="mch-sidebar">
          <div className="mch-sidebar-header">
            <div className="mch-sidebar-header-left">
              <h2>Messages</h2>
              {unreadTotal > 0 && (
                <span className="mch-badge-total">{unreadTotal}</span>
              )}
            </div>
            <button className="mch-icon-btn" title="New Chat">
              <i className="bi bi-pencil-square"></i>
            </button>
          </div>

          <div className="mch-search-wrap">
            <i className="bi bi-search mch-search-icon"></i>
            <input
              type="text"
              placeholder="Search messages..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="mch-filter-tabs">
            {[
              { key: "all", label: "All", count: conversations.length },
              { key: "groups", label: "Groups", count: groupCount },
              { key: "individual", label: "Individual", count: null },
            ].map((f) => (
              <button
                key={f.key}
                className={`mch-filter-tab${activeFilter === f.key ? " mch-tab-active" : ""}`}
                onClick={() => setActiveFilter(f.key)}
              >
                {f.label}
                {f.count !== null && (
                  <span className="mch-tab-pill">{f.count}</span>
                )}
              </button>
            ))}
          </div>

          <div className="mch-conv-list">
            {filtered.map((conv) => (
              <div
                key={conv.id}
                className={`mch-conv-item${selectedChat?.id === conv.id ? " mch-conv-selected" : ""}${conv.unreadCount > 0 ? " mch-conv-unread" : ""}`}
                onClick={() => {
                  setSelectedChat(conv);
                  setShowProfile(true);
                }}
              >
                <div className="mch-avatar-wrap">
                  <img src={conv.studentAvatar} alt={conv.studentName} />
                  {conv.isOnline && <span className="mch-dot-online" />}
                  {conv.type === "group" && (
                    <span className="mch-group-badge">
                      <i className="bi bi-people-fill"></i>
                    </span>
                  )}
                </div>
                <div className="mch-conv-body">
                  <div className="mch-conv-top">
                    <span className="mch-conv-name">
                      {conv.isPinned && (
                        <i className="bi bi-pin-angle-fill mch-pin"></i>
                      )}
                      {conv.studentName}
                    </span>
                    <span className="mch-conv-time">
                      {formatTime(conv.lastMessageTime)}
                    </span>
                  </div>
                  <div className="mch-conv-bottom">
                    {conv.isTyping ? (
                      <span className="mch-typing-text">
                        <span className="mch-dot" />
                        <span className="mch-dot" />
                        <span className="mch-dot" /> typing...
                      </span>
                    ) : (
                      <span className="mch-last-msg">
                        {conv.lastMessage.length > 36
                          ? conv.lastMessage.slice(0, 36) + "…"
                          : conv.lastMessage}
                      </span>
                    )}
                    {conv.unreadCount > 0 && (
                      <span className="mch-unread-pill">
                        {conv.unreadCount > 99 ? "99+" : conv.unreadCount}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ══════════ PANEL 2 — CHAT WINDOW ══════════ */}
        <div className="mch-chat-panel">
          {selectedChat ? (
            <>
              {/* Chat Header */}
              <div className="mch-chat-header">
                <div className="mch-chat-header-left">
                  <div className="mch-avatar-wrap mch-avatar-sm">
                    <img
                      src={selectedChat.studentAvatar}
                      alt={selectedChat.studentName}
                    />
                    {selectedChat.isOnline && (
                      <span className="mch-dot-online" />
                    )}
                  </div>
                  <div>
                    <p className="mch-chat-name">{selectedChat.studentName}</p>
                    <p className="mch-chat-sub">
                      {selectedChat.type === "group" ? (
                        `${selectedChat.memberCount} members`
                      ) : selectedChat.isTyping ? (
                        <span className="mch-typing-green">typing...</span>
                      ) : selectedChat.isOnline ? (
                        <span className="mch-online-text">
                          <i
                            className="bi bi-circle-fill"
                            style={{ fontSize: "7px" }}
                          />{" "}
                          Online
                        </span>
                      ) : (
                        "Offline"
                      )}
                    </p>
                  </div>
                </div>
                <div className="mch-chat-header-actions">
                  <button className="mch-icon-btn" title="Search">
                    <i className="bi bi-search"></i>
                  </button>
                  <button className="mch-icon-btn" title="Voice Call">
                    <i className="bi bi-telephone-fill"></i>
                  </button>
                  <button className="mch-icon-btn" title="Video Call">
                    <i className="bi bi-camera-video-fill"></i>
                  </button>
                  <button
                    className={`mch-icon-btn${showProfile ? " mch-icon-btn-active" : ""}`}
                    title="View Profile"
                    onClick={() => setShowProfile((p) => !p)}
                  >
                    <i className="bi bi-layout-sidebar-reverse"></i>
                  </button>
                </div>
              </div>

              {/* Messages */}
              <div className="mch-messages">
                <div className="mch-date-chip">
                  <span>Today</span>
                </div>
                {(chatMessages[selectedChat.id] || []).map((msg) => (
                  <div
                    key={msg.id}
                    className={`mch-msg${msg.isMe ? " mch-msg-me" : " mch-msg-other"}`}
                  >
                    {!msg.isMe && (
                      <img
                        src={msg.avatar}
                        alt={msg.sender}
                        className="mch-msg-avatar"
                      />
                    )}
                    <div className="mch-msg-body">
                      {!msg.isMe && (
                        <span className="mch-msg-sender">{msg.sender}</span>
                      )}
                      <div className="mch-msg-bubble">
                        <p>{msg.message}</p>
                      </div>
                      <span className="mch-msg-time">{msg.time}</span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Input */}
              <div className="mch-input-bar">
                <button className="mch-icon-btn" title="Attach">
                  <i className="bi bi-paperclip"></i>
                </button>
                <button className="mch-icon-btn" title="Emoji">
                  <i className="bi bi-emoji-smile"></i>
                </button>
                <input
                  type="text"
                  placeholder="Type a message..."
                  value={messageInput}
                  onChange={(e) => setMessageInput(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleSend()}
                />
                <button className="mch-send-btn" onClick={handleSend}>
                  <i className="bi bi-send-fill"></i>
                </button>
              </div>
            </>
          ) : (
            <div className="mch-empty">
              <i className="bi bi-chat-dots"></i>
              <h3>Select a conversation</h3>
              <p>Choose a student from the list to start chatting</p>
            </div>
          )}
        </div>

        {/* ══════════ PANEL 3 — PROFILE / INFO ══════════ */}
        {selectedChat && showProfile && (
          <div className="mch-profile-panel">
            {/* Avatar + Name */}
            <div className="mch-profile-hero">
              <img
                src={selectedChat.studentAvatar}
                alt={selectedChat.studentName}
                className="mch-profile-avatar"
              />
              <h3 className="mch-profile-name">{selectedChat.studentName}</h3>
              <p className="mch-profile-course">
                <i className="bi bi-book"></i> {selectedChat.course}
              </p>
              {selectedChat.type === "individual" && selectedChat.isOnline && (
                <span className="mch-profile-status-pill">
                  <i
                    className="bi bi-circle-fill"
                    style={{ fontSize: "7px" }}
                  />{" "}
                  Online
                </span>
              )}
            </div>

            {/* Bio */}
            <div className="mch-profile-section">
              <p className="mch-profile-section-title">
                <i className="bi bi-info-circle"></i>
                {selectedChat.type === "group" ? "About Group" : "About"}
              </p>
              <p className="mch-profile-bio">{selectedChat.bio}</p>
            </div>

            {/* Individual: Progress */}
            {selectedChat.type === "individual" && (
              <div className="mch-profile-section">
                <p className="mch-profile-section-title">
                  <i className="bi bi-bar-chart"></i> Course Progress
                </p>
                <div className="mch-progress-wrap">
                  <div className="mch-progress-top">
                    <span>{selectedChat.course}</span>
                    <span className="mch-progress-pct">
                      {selectedChat.progress}%
                    </span>
                  </div>
                  <div className="mch-progress-bar">
                    <div
                      className="mch-progress-fill"
                      style={{ width: `${selectedChat.progress}%` }}
                    />
                  </div>
                </div>
                <div className="mch-profile-meta">
                  <span>
                    <i className="bi bi-calendar3"></i> Joined{" "}
                    {selectedChat.joinedDate}
                  </span>
                </div>
              </div>
            )}

            {/* Group: Members */}
            {selectedChat.type === "group" && selectedChat.members && (
              <div className="mch-profile-section">
                <div className="mch-section-row">
                  <p className="mch-profile-section-title">
                    <i className="bi bi-people"></i> Members
                  </p>
                  <span className="mch-see-all">See all</span>
                </div>
                <div className="mch-members-list">
                  {selectedChat.members.map((m, i) => (
                    <div key={i} className="mch-member-row">
                      <img src={m.avatar} alt={m.name} />
                      <span>{m.name}</span>
                    </div>
                  ))}
                  {selectedChat.memberCount > selectedChat.members.length && (
                    <div className="mch-member-more">
                      +{selectedChat.memberCount - selectedChat.members.length}{" "}
                      more
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Shared Files */}
            {selectedChat.sharedFiles?.length > 0 && (
              <div className="mch-profile-section">
                <div className="mch-section-row">
                  <p className="mch-profile-section-title">
                    <i className="bi bi-folder"></i> Shared Files
                  </p>
                  <span className="mch-see-all">See all</span>
                </div>
                <div className="mch-files-list">
                  {selectedChat.sharedFiles.map((f, i) => (
                    <div key={i} className="mch-file-row">
                      <div className="mch-file-icon" style={{ color: f.color }}>
                        <i className={`bi ${f.icon}`}></i>
                      </div>
                      <div className="mch-file-info">
                        <span className="mch-file-name">{f.name}</span>
                        <span className="mch-file-size">{f.size}</span>
                      </div>
                      <button className="mch-file-dl">
                        <i className="bi bi-download"></i>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Shared Links */}
            {selectedChat.sharedLinks?.length > 0 && (
              <div className="mch-profile-section">
                <div className="mch-section-row">
                  <p className="mch-profile-section-title">
                    <i className="bi bi-link-45deg"></i> Shared Links
                  </p>
                  <span className="mch-see-all">See all</span>
                </div>
                <div className="mch-links-list">
                  {selectedChat.sharedLinks.map((l, i) => (
                    <div key={i} className="mch-link-row">
                      <div className="mch-link-favicon">
                        <i className="bi bi-globe"></i>
                      </div>
                      <div className="mch-link-info">
                        <span className="mch-link-title">{l.title}</span>
                        <span className="mch-link-url">{l.url}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Action buttons */}
            {selectedChat.type === "individual" && (
              <div className="mch-profile-actions">
                <button className="mch-profile-btn mch-btn-primary">
                  <i className="bi bi-calendar-check"></i> Schedule Session
                </button>
                <button className="mch-profile-btn mch-btn-outline">
                  <i className="bi bi-flag"></i> Report Student
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </MyMasterLayout>
  );
};

export default ChatList;
